import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/auth.service';

@Component({ standalone: false,
  selector: 'app-footer-public',
  templateUrl: './footer-public.component.html',
  styleUrls: ['./footer-public.component.scss']
})
export class FooterPublicComponent implements OnInit {
  @ViewChild('footerRef', { static: true }) footerRef!: ElementRef;
  test: Date = new Date();
  isVisible = false;

  constructor(
      private authService: AuthService,
  ){ }

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  ngOnInit(): void {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          observer.disconnect(); // only trigger once
        }
      },
      { threshold: 0.1 } // triggers when 10% of footer is visible
    );

    observer.observe(this.footerRef.nativeElement);
  }
}